// Version
export const GET_APP = 'GET_APP'
export const SWITCH_UI = 'SWITCH_UI'
export const GET_SERVER_VERSION = 'GET_SERVER_VERSION'
export const GET_HEALTH = 'GET_HEALTH'
export const SET_MS_CONNECTION_STATUS = 'SET_MS_CONNECTION_STATUS'
export const GET_DEAMON_VERSION = 'GET_DEAMON_VERSION'
export const SET_MS_ERRORS = 'SET_MS_ERRORS'
